import { apiRequest } from '@/api/client';
import type { GuidelineDetail, GuidelineSummary } from '@/types';

export async function fetchGuidelines(
  accessToken: string,
  type?: string,
  sessionId?: string | null,
): Promise<GuidelineSummary[]> {
  const qs = type ? `?type=${encodeURIComponent(type)}` : '';
  const data = await apiRequest<{ guidelines?: GuidelineSummary[]; items?: GuidelineSummary[] }>(
    `/guidelines${qs}`,
    { accessToken, sessionId },
  );
  return data.guidelines ?? data.items ?? (Array.isArray(data) ? data : []);
}

export async function fetchGuideline(
  slug: string,
  accessToken: string,
  sessionId?: string | null,
): Promise<GuidelineDetail> {
  return apiRequest<GuidelineDetail>(
    `/guidelines/${encodeURIComponent(slug)}`,
    { accessToken, sessionId },
  );
}
